<template>
  <div class="home">
    <TopHeader
      :homeBtnHide="true"
      :LoginBtnShow="LoginBtnShow"
      :banner="banner"
      :welcome="welcome"
      :logo="logo"
      @handleLogin="handleLogin"
      @handleOrder="handleOrder"
      @registShowEvent="registShowEvent"
      @loginOk="loginOk"
      @tiggerPage="tiggerPage"
      @loginOut="loginOut"
      :languageList= "languageList"
    ></TopHeader>
    <div class="marquee-box">
      <div class="w1280 overflow">
        <div class="marquee-title">
          <img src="../assets/images/home/redClock.png" alt />
          <span>{{$t('Announcement')}}</span>
        </div>
        <marquee v-if="form.isOpenAd==='T'" scrollamount="5">{{form.adContent}}</marquee>
      </div>
    </div>
    <router-view></router-view>
    <loginPlane
      ref="loginwrap"
      :loginShow="loginShow"
      @closeLogin="closeLogin"
      @registShowEvent="registShowEvent"
      @loginOk="loginOk"
      :logo="logo"
    ></loginPlane>
    <registered
      :registShow="registShow"
      @toLogin="toLogin"
      @clsoeRegist="clsoeRegist"
      :registType="registType"
      :logo="logo"
      @termsOfServiceEvent="termsOfServiceEvent"
    ></registered>
    <TermsOfService
      :termsOfServiceshow="termsOfServiceshow"
      @termsOfServiceEvent="termsOfServiceEvent"
      :userInfoText="userInfoText"
    ></TermsOfService>
    <CopyRight :logo="logo"></CopyRight>
    <!-- 侧边固定栏 -->
    <!-- <img class="tips" src="../assets/images/home/tips.png" />
    <div class="right-fiex-box">
      <div class="right-fiex-item">
        <div class="right-fiex-top"></div>
        <p>导游预约</p>
      </div>
      <div class="right-fiex-item right-fiex-item2">
        <div class="right-fiex-top"></div>
        <p>观光车购票</p>
      </div>
    </div> -->

    <div class="right-fiex-box2">
      <div class="right-fiex-item" @click="toIphone">
        <div class="right-fiex-top"></div>
        <p>{{$t('buyTicket.telephoneConsultation')}}</p>
      </div>
      <div class="right-fiex-item right-fiex-item2" @click="toWX">
        <div class="right-fiex-top"></div>
        <p>{{$t('buyTicket.onlineConsultation')}}</p>
      </div>
      <div class="right-fiex-item right-fiex-item3" @click="showWeChatQc">
        <div class="right-fiex-top"></div>
        <p>{{$t('buyTicket.weChatOfficialAccount')}}</p>
      </div>
    </div>
    <!-- <el-dialog
      custom-class="notice-dialog"
      width="40%"
      height="50%"
      :show-close="false"
      title
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div class="title">{{$t('buyTicket.ticketingInstructions')}}</div>
      <span class="notice panel-body" v-html="notice"></span>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!agree" class="cancal" :disabled="false" type="info">{{$t('buyTicket.PleaseRead')}}（{{codeText}}S)</el-button>
        <el-checkbox
          v-else
          class="selctes"
          style="background:#241008;color:#fff;padding:12px 20px;border-radius: 4px"
          v-model="checkStatus"
          @change="handleNoticeChange"
        >{{$t('buyTicket.IRead')}}</el-checkbox>
        <el-button

          @click="dialogVisible = false"

        >我已详细阅读，继续预定</el-button>
      </span>
    </el-dialog> -->
    <!-- 公众号二维码 -->
    <el-dialog title="" width="532px" :visible.sync="weChatQc" >
      <div class="we-chat-qc">
        <p>{{$t('WeChatTitle')}}</p>
        <div class="img-box">
          <img src="../assets/images/home/yingzheng.png" />
          <p>{{$t('PleaseUseWeChat')}}</p>
        </div>
        <el-button class="handle" v-if="!CountDownComplete" disabled type="info" plain>{{$t('CountDown')}}({{countDown}})</el-button>
        <el-button class="handle" v-if="CountDownComplete" @click="weChatQc = false" type="danger" plain>{{$t('CountDownComplete')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopHeader from '../components/TopHeader_2'
import CopyRight from '../components/CopyRight_2'
import { config } from '@/constant/config'
import loginPlane from './login'
import registered from './registered'
import TermsOfService from '../components/TermsOfService'
import { getToken, sysConfig, Login, getInfoConfiguration, getDictList } from '@/api/buyTicket'
import { page } from '@/api/login.js'

export default {
  components: {
    TopHeader,
    CopyRight,
    loginPlane,
    registered,
    TermsOfService
  },
  data () {
    return {
      countDown: 3,
      CountDownComplete: false,
      termsOfServiceshow: false,
      loginShow: false,
      registShow: false,
      registType: 0,
      currentDate: '',
      tomorrowDate: '',
      date: [],
      dateList: [],
      checkStatus: false,
      form: {},
      dialogVisible: true,
      list: [],
      allSelectNumber: 0,
      allPrice: 0,
      week: [
        { cn: '一', en: 'MON' },
        { cn: '二', en: 'TUE' },
        { cn: '三', en: 'WED' },
        { cn: '四', en: 'THU' },
        { cn: '五', en: 'FRI' },
        { cn: '六', en: 'SAT' },
        { cn: '日', en: 'SUN' }
      ],
      pickerOptions: {
        disabledDate (time) {
          const curDate = (new Date()).getTime()
          // 这里算出一个月的毫秒数,
          const day = 14 * 24 * 3600 * 1000
          const bday = 2 * 24 * 3600 * 1000
          const dateRegion = curDate + day
          return time.getTime() < curDate + bday ||
          time.getTime() > dateRegion
        }
      },
      ordinarypickerOptions: {
        disabledDate (time) {
          const curDate = (new Date()).getTime()
          // 这里算出一个月的毫秒数,
          const day = 14 * 24 * 3600 * 1000
          const dateRegion = curDate + day
          return time.getTime() < curDate ||
          time.getTime() > dateRegion
        }
      },
      flag: false,
      tiketType: 'spot',
      flightLineList: [],
      tabIndex: 0,
      ReservationConfig: {},
      timeSharingIndex: null,
      selectDate: '',
      timeSharing: [],
      dateBox: [],
      valueDate: '',
      selectNum: 1,
      ticketList: [],
      customize: '',
      LoginBtnShow: false,
      centerDialogVisible: false,
      disable: false,
      iframeUrl: '',
      dialogLogin: false,
      dialogErrorVisible: false,
      remark: '',
      tableKey: 0,
      currentTab: 0,
      ordinaryValueDate: null,
      notice: '',
      isOpenNotice: false,
      codeText: 5,
      agree: false,
      banner: [],
      welcome: '',
      logo: '',
      oldticketList: null,
      timeSharingSelect: false,
      path: null,
      maxQuantit: null,
      noticeTicket: '',
      dialogVisibleTicket: false,
      pageIndex: '1',
      weChatQc: false,
      telephomeNumber: null,
      qqNumber: null,
      userInfoText: null,
      languageList: null,
      clockers: { // 定时器
        countDown: null
      }
    }
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    Object.keys(this.clockers).forEach(item => {
      window.clearInterval(this.clockers[item])
    })
  },
  computed: {

  },
  created () {
    // const tempDate = new Date()
    // const acquired = new Date()
    // this.initDate()
    this.init()
    // this.getList()
    // this.getmaxQuantit()
    // 默认弹出二维码
    // this.showWeChatQc()
  },
  mounted () {
    this.pageIndex = this.$route.query.index || '1'
  },
  methods: {
    showWeChatQc () {
      this.weChatQc = true
      this.countDown = 3
      this.CountDownComplete = false
      // 开始倒计时
      this.clockers.countDown = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          window.clearInterval(this.clockers.countDown)
          this.clockers.countDown = null
          this.CountDownComplete = true
        }
      }, 1000)
    },
    toWX () {
      window.open(`http://wpa.qq.com/msgrd?v=3&uin=${this.qqNumber}&site=qq&menu=yes`)
    },
    toIphone () {
      this.$confirm(this.telephomeNumber, this.$t('buyTicket.telephoneConsultation'), {
        confirmButtonText: this.$t('Confirm'),
        showCancelButton: false,
        iconClass: 'el-icon-phone'
      })
    },
    tiggerPage (index) {
      this.pageIndex = index
      this.$router.push('/myOrder')
    },
    ticketKindVOListShow (text) {
      if (text) {
        const regExp = new RegExp('<img src="/file/download/', 'g')
        text = text.replace(regExp, `src="${config.BASE_URL}/file/download/`)
        text = text.replace(/<img/gi, '<img style="max-width:96%;display:block;height:auto;margin:0 2%;"')
      }
      this.noticeTicket = text
      this.dialogVisibleTicket = true
    },
    handleNoticeChange () {
      window.setTimeout(() => {
        // this.dialogVisible = false
        this.checkStatus = false
      }, 500)
    },
    init () {
      console.log('home')
      const url = window.location.search
      const str = url.substr(url.indexOf('?'))
      const strs = str.split('&')
      const orgId = strs[0].split('=')[1]
      if (url.indexOf('?') !== -1) {
        sessionStorage.setItem('orgId', orgId)
        if (sessionStorage.getItem('token')) {
          if (sessionStorage.getItem('loginState') === '1') {
            this.LoginBtnShow = true
          }
          this.sysConfig(orgId, true)
          this.getInfoConfiguration()
          this.getLanguages()
          sessionStorage.setItem('LoginHref', window.location.href)
        } else {
          sessionStorage.setItem('homeHref', window.location.href)
          this.token(orgId)
        }
      } else {
        sessionStorage.setItem('homeHref', window.location.href)
        this.token(orgId)
      }
    },
    // 获取手机，qq
    getInfoConfiguration () {
      getInfoConfiguration('OFFICIAL_QQ_NUMBER').then(res => {
        if (res.code === 0 && res.data) {
          this.qqNumber = res.data.value
        }
      })
      getInfoConfiguration('OFFICIAL_TELEPHONE_NUMBER').then(res => {
        if (res.code === 0 && res.data) {
          this.telephomeNumber = res.data.value
        }
      })
    },
    // 退出登录
    loginOut () {
      sessionStorage.setItem('loginOutState', 'T')
      this.LoginBtnShow = false
      if (this.path !== '/buyTicket') {
        this.$router.push('/')
      } else {
        this.$router.go(0)
      }
      this.$router.go(0)
    },
    token (orgId) {
      getToken(orgId).then(res => {
        if (res.code === 0) {
          sessionStorage.setItem('token', res.data)
          // 查询预约余票量
          this.getInfoConfiguration()
          this.sysConfig(orgId)
          // 获取用户协议
          this.getUserPage()
          this.getLanguages()
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    getLanguages () {
      getDictList('languages').then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.code === 'Traditional_Chinese') {
              item.value = '繁體中文'
            }
            if (item.code === 'English') {
              item.value = 'English (US)'
            }
            if (item.code === 'Korean') {
              item.value = '한국어'
            }
            if (item.code === 'Japanese') {
              item.value = '日本語'
            }
          })
          this.languageList = res.data
        } else {
          this.languageList = [{
            code: 'Simplified_Chinese',
            value: '简体中文',
            typeCode: 'languages',
            typeValue: '语言',
            isSys: 'T',
            sort: 1
          }]
        }
      })
    },
    getUserPage () {
      page({
        limit: 10,
        page: 1,
        protocolName: '用户使用协议'
      }).then((res) => {
        if (res.code === 0) {
          if (res.data.list.length > 0) {
            res.data.list[0].protocolContent = res.data.list[0].protocolContent ? res.data.list[0].protocolContent.replace('<img class="wscnph" src="', '<img class="wscnph" src="' + config.BASE_URL + '/') : ''
            if (res.data.list[0].protocolContent) {
              const regExp = new RegExp('<img src="/file/download/', 'g')
              res.data.list[0].protocolContent = res.data.list[0].protocolContent.replace(regExp, `<img src="${config.BASE_URL}/file/download/`)
              res.data.list[0].protocolContent = res.data.list[0].protocolContent.replace(/\<img/gi, '<img style="max-width:96%;display:block;height:auto;margin:0 2%;"')
            }
            this.userInfoText = res.data.list[0].protocolContent
          }
        }
      })
    },
    handleToLogin () {
      this.centerDialogVisible = false
      const returnUrl = window.location.href
      Login(returnUrl).then(res => {
        this.dialogLogin = true
        this.iframeUrl = res
        // window.location = res
      })
    },
    handleOrder () {
      if (this.LoginBtnShow) {
        this.centerDialogVisible = true
      } else {
        console.log(123)
        // this.$router.push('/myOrder')
      }
    },
    handleLogin (path) {
      this.loginShow = true
      this.LoginBtnShow = false
      this.path = path
      // const returnUrl = window.location.href
      // Login(returnUrl).then(res => {
      //   this.dialogLogin = true
      //   this.iframeUrl = res
      //   // window.location = res
      // })
    },
    loginOk () {
      sessionStorage.setItem('loginOutState', 'F')
      // this.getReservationConfig()
      this.sysConfig(sessionStorage.getItem('orgId'))
      localStorage.setItem('dialogVisibleShow', '1')
      this.LoginBtnShow = true
      sessionStorage.setItem('loginState', '1')
      if (this.path === '/myOrder') {
        this.$router.push('/myOrder')
      } else {
        this.$router.go(0)
      }
    },
    closeLogin () {
      this.loginShow = false
    },
    clsoeRegist () {
      this.registShow = false
    },
    // closeStatement(){
    //   this.statementShow = !this.statementShow
    // },
    registShowEvent (i) {
      this.registType = i
      this.loginShow = false
      this.registShow = true
    },
    toLogin () {
      this.registShow = false
      this.loginShow = true
    },
    termsOfServiceEvent () {
      this.termsOfServiceshow = !this.termsOfServiceshow
    },
    handleBlur (e) {
      if (!this.customize) {
        this.selectNum = 1
        this.customize = ''
      }
    },
    handleChangeNum (e) {
      this.selectNum = e
    },
    handleNum (num) {
      this.selectNum = num
      this.customize = ''
    },
    sysConfig (orgId, showNotice) {
      this.form = {}
      const data = {
        typeCode: 'PC',
        orgId: orgId,
        languages: localStorage.getItem('languageCode')
      }
      sysConfig(data).then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.welcome = res.data.welcomeWords
            this.logo = config.BASE_URL + res.data.banneLogorUrl
            console.log(this.logo, 'logo')
            const imgList = res.data.bannerUrl.split(',')
            imgList.forEach(item => {
              this.banner.push(config.BASE_URL + item)
            })
            document.title = res.data.mallName
            if (res.data.notice) {
              // console.log(res.data.notice)
              // const regExp = new RegExp('<img src="file/download/', 'g')
              const regExp = /src="[/]?file\/download\//g
              res.data.notice = res.data.notice.replace(regExp, `src="${config.BASE_URL}/file/download/`)
              // res.data.notice = res.data.notice.replace(/<img/gi, '<img style="max-width:96%;display:block;height:auto;margin:0 2%;"')
            }
            this.notice = res.data.notice
            this.isOpenNotice = res.data.isOpenNotice
            if (res.data.isOpenNotice === 'T' && showNotice === true) {
              // this.dialogVisible = true
              this.codeText = res.data.countDown
              this.timer = setInterval(() => {
                if (this.codeText === 0) {
                  this.agree = true
                  clearInterval(this.timer)
                }
                this.codeText--
              }, 1000)
            }
            // 温馨提示
            if (res.data.warmPrompt) {
              localStorage.setItem('warmPrompt', res.data.warmPrompt)
            }
            this.form = res.data
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        }
      })
    },
    handleNotice () {
      // this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.tiketType_box {
  margin-top: 20px;
  padding-bottom: 50px;
}
.marquee-box {
  // position: fixed;
  padding-top: 79px;
  top: 80px;
  width: 100%;
}
.marquee-title {
  float: left;
  width: 58px;
  line-height: 58px;
  height: 58px;
  margin-right: 18px;
}
.marquee-title span {
  display: inline-block;
  color: #FF0000;
  font-size: 14px;
  font-weight: bold;
  vertical-align: middle;
}
.marquee-title img {
  display: inline-block;
  width: 15px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}
marquee {
  overflow: hidden;
  float: left;
  width: calc(100% - 76px);
  display: block;
  line-height: 58px;
  color: #FF0000;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  height: 58px;
  font-size: 14px;
}

.noticeBtn {
  cursor: pointer;
  float: right;
  line-height: 40px;
  text-align: center;
  background-color: #ffb000;
  padding: 0 15px;
  border-radius: 20px;
  &:hover {
    opacity: 0.8;
  }
  .ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    vertical-align: middle;
    background: url(../assets/images/notice.png) no-repeat;
    background-size: 100% 100%;
    margin-right: 10px;
  }
  .text {
    vertical-align: middle;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
}

.buyticket {
  // margin-bottom: 40px;
  border-radius: 5px;
  .tab {
    overflow: hidden;
    span {
      float: left;
      width: 130px;
      height: 100%;
      line-height: 44px;
      border-radius: 6px;
      overflow: hidden;
      font-style: normal;
      font-size: 14px;
      background: #fff;
      text-align: center;
      cursor: pointer;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-right: 10px;
      &.active {
        background: #241008;
        color: #fff;
      }
    }
  }
  .pane {
    position: relative;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px 0px rgba(20, 34, 44, 0.15);
    padding: 30px 60px;
    .buyticket-box {
      overflow: hidden;
      .buyticket-div {
        overflow: hidden;
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;
        .title {
          display: flex;
          font-size: 16px;
          color: #2D3E54;
          font-weight: bold;
          line-height: 26px;
          height: 46px;
          img {
            width: 24px;
            height: 24px;
            margin-right: 5px;
          }
        }
        .buyticket-shadow {
          box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
        }
        .buyticket-right {
          overflow: hidden;
          width: 943px;
          box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
          .date-box-title {
            height: 48px;
            line-height: 48px;
            background: #F1F6FF;
            opacity: 1;
            border-radius: 8px 8px 0px 0px;
            div {
              width: 134px;
              text-align: center;
            }
          }
          .date-box {
            display: flex;
            justify-content: space-between;
            .date-item {
              width: 134px;
              text-align: center;
              height: 58px;
              line-height: 58px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #424855;
              opacity: 0.5;
              margin: 10px;
              cursor: pointer;
            }
            .date-item-open {
              color: #4E5F84;
              opacity: 1;
              border-radius: 4px;

            }
            .date-item-noopen {
              pointer-events: none;
            }
            .date-item-isActive {
              background: #A0393E;
              color: #FFFFFF;
            }
          }
          .select-list {
            display: flex;
            justify-content: flex-start;
            .noMR {
              margin-right: 0 !important;
            }
            > span {
              display: inline-block;
              flex-shrink: 0;
              width: 203px;
              height: 65px;
              border: 1px solid #A7AEBB;
              opacity: 1;
              border-radius: 4px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              text-align: center;
              cursor: pointer;
              margin-right: 44px;
              color: #424855;
              &.active {
                background: #A0393E;
                box-shadow: 0px 3px 6px rgba(24, 60, 80, 0.08);
                opacity: 1;
                border-radius: 4px;
                color: #FFFFFF;
              }
              > p {
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 32px;
              }
              > p:nth-child(2) {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
              }
              &.disable {
                pointer-events: none;
                opacity: 0.5;
              }
            }
          }
          .time-select-text {
            line-height: 44px;
            color: #ec2f2f;
          }
          .select-btn {
            float: right;
            width: 203px;
            height: 44px;
            line-height: 44px;
            border-radius: 6px;
            .input-show {
              display: block;
              width: 100%;
              height: 100%;
              line-height: 44px;
              text-align: center;
              height: 44px;
              background: #f6f6f6;
              border-radius: 6px;
              font-size: 16px;
              color: #333;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              outline: none;
              text-align: center;
              &.active {
                background: #241008;
                color: #fff;
              }
              &:hover {
                opacity: 0.8;
              }
            }
            .picker-options {
              display: block;
              width: 100%;
              height: 44px;
              line-height: 44px;
              .el-input {
                width: 100% !important;
                background: #f6f6f6;
              }
            }
          }
        }
      }
      .buyticket-footer {
        overflow: hidden;
        display: flex;
        border-top: 1px solid #f6f6f6;
        padding-top: 29px;
        margin-top: 31px;
        .booking-notice {
          flex: 1;
          height: 58px;
          line-height: 58px;
          img {
            display: inline-block;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 4px;
            cursor: pointer;
          }
          span {
            display: inline-block;
            font-size: 16px;
            color: #ec2f2f;
            vertical-align: middle;
            cursor: pointer;
          }
        }
        .booking-msg {
          flex: 1;
          overflow: hidden;
          line-height: 58px;
          text-align: right;
          .msg {
            display: inline-block;
            vertical-align: middle;
            font-size: 16px;
            color: #333;
            span {
              display: inline-block;
              color: #ff4400;
              margin: 0 12px;
            }
          }
        }
      }
    }
    .schedule {
      position: absolute;
      right: -185px;
      top: 0;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 165px;
        height: 40px;
        background: #853D3F;
        color: #FFFFFF;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
      }
      .content {
        padding: 16px 16px;
        background: white;
        padding-right: 0;
        .activity {
          color: #853D3F;
        }
      }
    }
    .dateSelect {
      margin-bottom: 16px;
      .label {
        font-weight: bold;
        line-height: 40px;
        margin-right: 15px;
      }
      .btn {
        display: inline-block;
        vertical-align: middle;
        min-width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 15px;
        border-radius: 15px;
        cursor: pointer;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .btn.right {
        float: right;
        /* right: 20px; */
      }
      .btn.current {
        color: #fff;
        background-color: #21a4ff;
      }
    }
    .ticketDetail /deep/ .el-table::before {
      height: 0;
    }
    .ticketDetail /deep/ th.is-leaf {
      background-color: #21a4ff;
      color: #fff;
      border-bottom: 12px solid #fff;
    }
    .ticketDetail /deep/ th.is-leaf:nth-child(1) {
      background: url(../assets/images/border_th_l.png) #21a4ff no-repeat left;
    }
    .ticketDetail /deep/ th.is-leaf:nth-last-child(2) {
      background: url(../assets/images/border_th_r.png) #21a4ff no-repeat right;
    }
    .ticketDetail /deep/ td {
      background-color: #f7f7f7;
      border-bottom: 12px solid #fff;
      padding: 10px 0;
    }
    .ticketDetail /deep/ td .cell {
      font-weight: bold;
    }
    .ticketDetail /deep/ td:nth-child(1) {
      background: url(../assets/images/border_td_l.png) #f7f7f7 no-repeat left;
    }
    .ticketDetail /deep/ td:nth-last-child(2) {
      background: url(../assets/images/border_td_r.png) #f7f7f7 no-repeat right;
    }
  }
}

.reserveBtn {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
  border-radius: 20px;
  background-color: #ffb000;
  cursor: pointer;
}
.reserveBtn:hover {
  background-color: #faab00;
}
.mb40 {
  margin-bottom: 40px;
}
.main-box {
  // padding: 30px 0;
  padding-bottom: 50px;
  .announcements {
    width: 100%;
    height: 308px;
    margin-top: 20px;
    background: white;
    .title {
      position: relative;
      height: 64px;
      background: url("../assets/images/home/announcements.png");
    }
    .title :nth-child(1) {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
    }
    .title :nth-child(2) {
      position: absolute;
      top: 50%;
      right: 40px;
      transform: translateY(-50%);
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
      cursor: pointer;
    }
    .list {
      display: flex;
      padding-top: 32px;
      padding-bottom: 20px;
      flex-wrap: wrap;
    }
    .list-item {
      width: 50%;
      display: flex;
      flex-shrink: 0;
      justify-content: space-around;
      margin-bottom: 12px;
      :nth-child(1) {
        color: #0C121D;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
      }
      :nth-child(1)::before{
        content: '•';
        font-size: 18px;
        padding-right: 6px;
        color: #A7AEBB;;
      }
      :nth-child(2) {
        color: #0C121D;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
      }
    }
  }
  .information {
    background: white;
    margin-top: 20px;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 64px;
      background: url("../assets/images/home/announcements.png");
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .content {
      padding: 32px 70px;
    }
  }
}
.notice-dialog {
  .selctes /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #fff;
  }
  .title {
    line-height: 20px;
    height: 20px;
    overflow: hidden;
    padding-left: 20px;
    position: relative;
    margin-bottom: 34px;
    &::before {
      position: absolute;
      top: 50%;
      width: 3px;
      height: 14px;
      background: rgba(191, 147, 48, 1);
      border-radius: 2px;
      margin-top: -7px;
      left: 8px;
      content: "";
    }
  }
  .notice {
    display: block;
    // min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
    line-height: 20px;
  }
  .btn {
    width: 130px;
    height: 44px;
    background: rgba(191, 147, 48, 1);
    border-radius: 6px;
    color: #fff;
    margin: 0 21px;
    &.cancal {
      background: #ccc;
      color: #333;
    }
  }
}
.dialog-login {
  iframe {
    display: block;
    width: 100%;
    height: 400px;
  }
}
.payBtn {
  display: inline-block;
  width: 80px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  font-size: 14px;
  border-radius: 3px;
  background:#A0393E;
  color: #fff;
  cursor: pointer;
  &.disable {
    background: #f6f6f6;
    cursor: no-drop;
    color: #cdcdcd;
  }
  &:hover {
    opacity: 0.8;
  }
}
.tips {
  position: fixed;
  top: 135px;
  right: 0;
}
.right-fiex-box {
  position: fixed;
  top: 410px;
  right: 20px;
  width: 72px;
  height: 168px;
  border: 1px solid #424855;
  border-radius: 4px;
  z-index: 9999;
  .right-fiex-item {
    width: 72px;
    height: 72px;
    padding-top: 12px;
    // background: #853D3F;
    cursor: pointer;
    opacity: 1;
    border-radius: 4px 4px 0px 0px;
    .right-fiex-top {
      width: 40px;
      height: 40px;
      background: url("../assets/images/home/tourGuide.png");
      margin: 0 auto;
    }
    >p {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 16px;
      color: #424855;
      opacity: 1;
      text-align: center;
    }
    &:hover {
      background: #853D3F;
      .right-fiex-top {
        background: url("../assets/images/home/tourGuideWhite.png");
      }
      >p {
        color: white;
      }
    }
  }
  .right-fiex-item2 {
    border-radius: 0px 0px 4px 4px;
    .right-fiex-top {
      background: url("../assets/images/home/tourBus.png");
    }
    &:hover {
      background: #853D3F;
      .right-fiex-top {
        background: url("../assets/images/home/tourBusWhite.png");
      }
      >p {
        color: white;
      }
    }
  }
}
.right-fiex-box2 {
  position: fixed;
  bottom: 50px;
  right: 20px;
  width: 72px;
  border: 1px solid #424855;
  border-radius: 4px;
  overflow: hidden;
  z-index: 9999;
  .right-fiex-item {
    width: 72px;
    height: 72px;
    padding-top: 12px;
    // background: #853D3F;
    cursor: pointer;
    opacity: 1;
    border-radius: 4px 4px 0px 0px;
    .right-fiex-top {
      width: 40px;
      height: 40px;
      background: url("../assets/images/home/phone.png");
      margin: 0 auto;
    }
    >p {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 16px;
      color: #424855;
      opacity: 1;
      text-align: center;
    }
    &:hover {
      background: #853D3F;
      .right-fiex-top {
        background: url("../assets/images/home/phoneWhite.png");
      }
      >p {
        color: white;
      }
    }
  }
  .right-fiex-item2 {
    border-radius: 0px 0px 0px 0px;
    .right-fiex-top {
      background: url("../assets/images/home/qq.png");
    }
    &:hover {
      background: #853D3F;
      .right-fiex-top {
        background: url("../assets/images/home/qqWhite.png");
      }
      >p {
        color: white;
      }
    }
  }
  .right-fiex-item3 {
    border-radius: 0px 0px 4px 4px;
    .right-fiex-top {
      background: url("../assets/images/home/weChatOfficialAccount.png");
    }
    &:hover {
      background: #853D3F;
      .right-fiex-top {
        background: url("../assets/images/home/whiteWeChatOfficialAccount.png");
      }
      >p {
        color: white;
      }
    }
  }
}
.buyticket-hint {
  display: flex;
  align-items: center;
  img {
    margin-right: 9px;
  }
}
/deep/ .el-dialog {
  box-shadow: 0px 3px 6px rgba(14, 78, 114, 0.08);
  opacity: 1;
  border-radius: 16px;
}
.we-chat-qc {
  text-align: center;
  p {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 31px;
    color: #2D3E54;
    opacity: 1;
  }
  .img-box {
    img {
      border: 1px dashed;
      margin-top: 40px;
    }
    p {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #2D3E54;
      opacity: 1;
    }
  }
}
.handle {
  width: 300px;
  margin-top: 15px;
}
</style>
